import { Component, OnInit, OnDestroy } from '@angular/core';
import { OrgBuilderFacade } from '@app/org-builder/state/org-builder.facade';
import { Router, ActivatedRoute } from '@angular/router';
import { froalaConfig } from '@app/shared/config/froala.config';
import { BusinessUnit } from '@entities/business-unit';
import { TeamMember } from '@entities/team-member';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Department } from '@entities/department';

@Component({
   selector: 'app-department-summary',
   templateUrl: './department-summary.component.html',
   styleUrls: ['./department-summary.component.scss'],
})
export class DepartmentSummaryComponent implements OnInit, OnDestroy {
   options = {
      ...froalaConfig,
      toolbarButtons: ['print'],
      documentReady: true,
   };

   orgName: string;
   logo: string;
   department: Department;
   teamMembers: TeamMember[];

   private destroyed$ = new Subject<void>();

   constructor(private facade: OrgBuilderFacade, private route: ActivatedRoute) {
      this.route.params.pipe(takeUntil(this.destroyed$)).subscribe((params) => {
         if (params['departmentId']) {
            this.facade.selectDepartment(params['departmentId']);
         }
      });
   }

   ngOnInit(): void {
      this.facade.departmentSummary$.pipe(takeUntil(this.destroyed$)).subscribe((dept) => {
         this.department = dept;
      });
      this.facade.organization$.pipe(takeUntil(this.destroyed$)).subscribe((org) => {
         if (org) {
            this.orgName = org.name;
            this.logo = org.logo;
         }
      });
      this.facade.teamMembers$.pipe(takeUntil(this.destroyed$)).subscribe((teamMembers) => {
         this.teamMembers = teamMembers;
      });
   }

   back() {
      history.back();
   }

   ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
   }
}
